import { useEffect, useRef } from "react";
import axios from "axios";
import { store } from "../store";
import { RootState } from "../reducers";
import { getPrinterHost, getPrinterUrl } from "../selectors/printer";
import { saveError } from "../actions/errors";

export function usePrinterConnectionPolling(intervalMs: number = 180000) {
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const dispatchSaveError = (errors: string[], message = "Printer Error") => {
    store.dispatch(
      saveError({
        message,
        errors,
      }),
    );
  };

  useEffect(() => {
    async function getStatus(printerHost: string, printerUrl: string) {
      try {
        await axios.get(`${printerHost}/Status?printerUrl=${printerUrl}`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } catch {
        dispatchSaveError(["Printer configuration is missing or incorrect"]);
      }
    }

    function poll() {
      try {
        const state = store.getState() as unknown as RootState;
        const printerHost = getPrinterHost(state);
        const printerUrl = getPrinterUrl(state);

        if (!printerHost || !printerUrl) {
          dispatchSaveError(["Printer configuration is missing"]);
          return;
        }
        getStatus(printerHost, printerUrl);
      } catch (err: unknown) {
        console.error("Polling error:", err);
      }
    }

    timerRef.current = setInterval(poll, intervalMs);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [intervalMs]);
}
